import { UploadOutlined } from "@ant-design/icons";
import { Button } from "antd";

import { useModal } from "../../../hooks/use-modal";
import { ImportDataModal } from "./import-data";

export const OpenImportModal = (props) => {
  const { type } = props;

  const { modal, open } = useModal(ImportDataModal);

  return (
    <>
      {modal}
      <Button
        ghost
        icon={<UploadOutlined />}
        id={`import-${type}-button`}
        onClick={() => open({ type })}
        type="primary"
      >
        Import
      </Button>
    </>
  );
};
